import { productsUrl } from "../resources";
import postRequest from '../common/postRequest.js';
import putRequest from '../common/putRequest.js'

async function createItem(data, token) {
    let url = `${productsUrl}`;
    return await postRequest.postDataWithToken(url, data, token);
}

async function updateItem(data, itemId, token) {
    
    let url = `${productsUrl}/${itemId}`;
    await putRequest.putDataWithToken(url, data, token);

}

async function updateItemStatus(data, itemId, token) {
    
    let url = `${productsUrl}/UpdateItemStatus/${itemId}`;
    await putRequest.putDataWithToken(url, data, token);

}

async function updateItemDiscount(data, itemId, token) {
    
    let url = `${productsUrl}/UpdateItemDiscount/${itemId}`;
    await putRequest.putDataWithToken(url, data, token);

}

async function updateParentItem(data, itemId, token) {
    
    let url = `${productsUrl}/UpdateParentItem/${itemId}`;
    await putRequest.putDataWithToken(url, data, token);

}

export default { 
    createItem,
    updateItem,
    updateItemStatus,
    updateParentItem,
    updateItemDiscount
}